import { render } from "./AddMeAsAPlayerComponent.vue?vue&type=template&id=4512646e&scoped=true"
import script from "./AddMeAsAPlayerComponent.vue?vue&type=script&lang=js"
export * from "./AddMeAsAPlayerComponent.vue?vue&type=script&lang=js"

import "./AddMeAsAPlayerComponent.vue?vue&type=style&index=0&id=4512646e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4512646e"]])

export default __exports__